import axios, {getAccessTokenUsingRefreshTokenGrant} from "../../utils/axiosInstance";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import {Auth} from "aws-amplify";
import {encryptAndStoreSessionVariable} from "../../utils/storageHelper";
import {getDemoModeSetting, getTrainingModeSetting} from "../../utils/trainingAndDemoModeHelper";

export const groupListReactive = async () => {
    let response = await axios.post("/groupListReactive", {});
    return response.data;
};
export const downloadAgentGroupOptionsListReactive = async () => {
    let response = await axios.post("/downloadAgentGroupOptionsListReactive", {});
    return response.data;
};
export const groupListForCCUsersOnDealsPageReactive = async () => {
    let response = await axios.post("/groupListForCCUsersOnDealsPageReactive", {});
    return response.data
};
export async function storeGroupListForCCUsersOnDealsPageInSessionSSE(){
    getAccessTokenUsingRefreshTokenGrant().then(accessToken => {
        let groups = []
        fetchEventSource(process.env.REACT_APP_AXIOS_BASE_URL +"/sse/groupListForCCUsersOnDealsPageReactive", {
            method: "POST",
            headers: {
                "Accept": "text/event-stream",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + accessToken,
            },
            //Get trainingMode and demoMode settings dynamically from session
            body: JSON.stringify({
                trainingMode: getTrainingModeSetting(),
                demoMode: getDemoModeSetting()
            }),
            openWhenHidden: true,
            onopen(res) {
                if (res.ok && res.status === 200) {
                    //console.log("Connection made ", res);
                } else if (
                    res.status >= 400 &&
                    res.status < 500 &&
                    res.status !== 429
                ) {
                    console.error("Client side error ", res);
                }
            },
            onmessage(event) {
                //while this is open it will continually push the event data into the groups array and update the zenGroupSessionStorage, it is not a change stream
                const value = JSON.parse(event.data)
                groups.push(value)
            },
            onclose() {
                //console.log("Connection closed by the server");
                encryptAndStoreSessionVariable("ccUsersDealsZenGroupSessionStorage", JSON.stringify(groups))
            },
            onerror(err) {
                console.error("There was an error from server", err);
            },
        })
    }).catch(error => {
        console.error(error)
    })
}

export const channelAndDistributionGroupListReactive = async () => {
    let response = await axios.post("/channelAndDistributionGroupListReactive", {});
    return response.data
};
export const userGroupListWithChannelInfoReactive = async () => {
    let response = await axios.post("/userGroupListWithChannelInfoReactive", {});
    return response.data;
};


export const distributionGroupListReactive = async () => {
    let response = await axios.post("/distributionGroupListReactive", {});
    return response.data.zenGroups;
};

export const getGroupManagementListReactive = async () => {
    let response = await axios.post("/groupManagementListReactive", {
    });
    return response.data;
};

export const getUsersInGroupListReactive = async (zenGroup) => {
    let response = await axios.post("/usersInGroupListReactive", {
        zenGroupId: zenGroup
    });
    return response.data;
};
export const ccGetUsersInGroupReactive = async (zenGroupId) => {
    let response = await axios.post("/ccGetUsersInGroupReactive", {
        zenGroupId: zenGroupId
    });
    return response.data;
};

export const ccGetAllNonChannelPartnerGroupsReactive = async () => {
    let response = await axios.post("/ccGetAllNonChannelPartnerGroupsReactive", {});
    return response.data;
};

export const createNewGroupReactive = async (groupName, channelPartnerCustomer, distributionGroup, assignedDistributionGroupId,
                                             zenGroupIdToCopyUser, zenGroupIdToCopyWhitelist, collectAgentTelemetry, whcpOnly, sslPinningMode,
                                             latestAgentVersionApproved, passwordExpirationPolicyInDays, agentInactiveDaysSetting, runAgentsInSafeMode,
                                             hideAgentsAutomatically, dmzMode, enableSystemTray, fortressAIReportMode, rollingUpdatePercentage, moduleTelemetryMode,
                                             agentKernelNetworking, earlyAdopter) => {
    return await axios.post("/createNewGroupReactive", {
        groupName,
        channelPartnerCustomer: channelPartnerCustomer,
        distributionGroup: distributionGroup,
        assignedDistributionGroupId: assignedDistributionGroupId,
        zenGroupIdToCopyUser: zenGroupIdToCopyUser,
        zenGroupIdToCopyWhitelist: zenGroupIdToCopyWhitelist,
        collectAgentTelemetry: collectAgentTelemetry,
        whcpOnly : whcpOnly,
        sslPinningMode: sslPinningMode,
        latestAgentVersionApproved: latestAgentVersionApproved,
        passwordExpirationPolicyInDays: passwordExpirationPolicyInDays,
        agentInactiveDaysSetting: agentInactiveDaysSetting,
        runAgentsInSafeMode: runAgentsInSafeMode,
        hideAgentsAutomatically: hideAgentsAutomatically,
        dmzMode: dmzMode,
        enableSystemTray: enableSystemTray,
        fortressAIReportMode: fortressAIReportMode,
        rollingUpdatePercentage: rollingUpdatePercentage,
        moduleTelemetryMode: moduleTelemetryMode,
        agentKernelNetworking: agentKernelNetworking,
        earlyAdopter: earlyAdopter
    });
};

export const bulkEditGroupSettingsReactive = async (zenGroupId, groupName, channelPartnerCustomer, distributionGroup, assignedDistributionGroupId,
                                             zenGroupIdToCopyUser, zenGroupIdToCopyWhitelist, collectAgentTelemetry, whcpOnly, sslPinningMode,
                                             latestAgentVersionApproved, passwordExpirationPolicyInDays, agentInactiveDaysSetting, runAgentsInSafeMode,
                                             hideAgentsAutomatically, dmzMode, enableSystemTray, enforceSSOLogin, fortressAIReportMode, rollingUpdatePercentage, moduleTelemetryMode,
                                             agentKernelNetworking, earlyAdopter) => {
    let response = await axios.post("/bulkEditGroupSettingsReactive", {
        zenGroupId: zenGroupId,
        groupName,
        channelPartnerCustomer: channelPartnerCustomer,
        distributionGroup: distributionGroup,
        assignedDistributionGroupId: assignedDistributionGroupId,
        zenGroupIdToCopyUser: zenGroupIdToCopyUser,
        zenGroupIdToCopyWhitelist: zenGroupIdToCopyWhitelist,
        collectAgentTelemetry: collectAgentTelemetry,
        whcpOnly : whcpOnly,
        sslPinningMode: sslPinningMode,
        latestAgentVersionApproved: latestAgentVersionApproved,
        passwordExpirationPolicyInDays: passwordExpirationPolicyInDays,
        agentInactiveDaysSetting: agentInactiveDaysSetting,
        runAgentsInSafeMode: runAgentsInSafeMode,
        hideAgentsAutomatically: hideAgentsAutomatically,
        dmzMode: dmzMode,
        enableSystemTray: enableSystemTray,
        enforceSSOLogin: enforceSSOLogin,
        fortressAIReportMode: fortressAIReportMode,
        rollingUpdatePercentage: rollingUpdatePercentage,
        moduleTelemetryMode: moduleTelemetryMode,
        agentKernelNetworking: agentKernelNetworking,
        earlyAdopter: earlyAdopter
    });
    return response.data
};

export const addToGroupReactive = async (username, groupId) => {
    const response = await axios.post("/addToGroupReactive", {
        usernameToAdd: username,
        zenGroupToAddTo: groupId
    });
    return response.data;
};

export const createUserFromGMReactive = async (username, groupId, includeSSOLoginLinkInNewUserEmail) => {
    const response = await axios.post("/createUserFromGMReactive", {
        usernameToCreate: username,
        zenGroupToAddTo: groupId,
        includeSSOLoginLinkInNewUserEmail: includeSSOLoginLinkInNewUserEmail
    });
    return response.data;
};

export const removeFromGroupReactive = async (username, groupId) => {
    return await axios.post("/removeFromGroupReactive", {
        userToRemove: username.trim(),
        zenGroupToRemoveFrom: groupId
    });
};

export const changeZenGroupGroupNameReactive = async (newGroupName, groupId) => {
    return await axios.post("/changeZenGroupGroupNameReactive", {
        "newGroupName": newGroupName,
        "zenGroupIdToChangeNameIn": groupId
    });
};

export const changeDefaultGroupReactive = async (zenGroup) => {
    return await axios.post("/changeDefaultGroupReactive", {
        newDefaultZenGroup: zenGroup,
    });
};
export const changeZenGroupDistributionGroupFieldReactive = async (zenGroup, value) => {
    const response = await axios.post("/changeZenGroupDistributionGroupFieldReactive", {
        zenGroupId: zenGroup,
        distributionGroupValue: value
    });
    return response.data;
};
export const changeZenGroupOrganizationNameReactive = async (newGroupName, groupId) => {
    return await axios.post("/changeZenGroupOrganizationNameReactive", {
        "newGroupOrganizationName": newGroupName,
        "zenGroupId": groupId
    });
};
export const updateGroupsAssignedDistributionGroupIdReactive = async (newAssignedDistributionGroupId, groupsToUpdateList, zenGroupIdToMakeNotDistributionGroup) => {
    const response = await axios.post("/updateGroupsAssignedDistributionGroupIdReactive", {
        newAssignedDistributionGroupId: newAssignedDistributionGroupId,
        groupsToUpdateList: groupsToUpdateList,
        zenGroupIdToMakeNotDistributionGroup: zenGroupIdToMakeNotDistributionGroup
    });
    return response.data;
}
export const changeZenGroupAssignedDistributionGroupIdReactive = async (zenGroupId, newAssignedDistributionGroupId) => {
    return await axios.post("/changeZenGroupAssignedDistributionGroupIdReactive", {
        zenGroupIdToUpdate: zenGroupId,
        newAssignedDistributionGroupId: newAssignedDistributionGroupId
    });
};
export const singleRemoveZenGroupAssignedDistributionGroupIdReactive = async (zenGroupId) => {
    return await axios.post("/singleRemoveZenGroupAssignedDistributionGroupIdReactive", {
        zenGroupIdToUpdate: zenGroupId
    });
};

export const editGroupWhcpReactive = async(zenGroupId, updatedWhcpOnly) =>{
    return await axios.post("/editGroupWhcpReactive", {
        zenGroupId :zenGroupId,
        updatedWhcpOnly : updatedWhcpOnly
    
    });

}
export const changeGroupCollectAgentTelemetrySettingReactive = async (zenGroupId, collectAgentTelemetry) => {
    return await axios.post("/changeGroupCollectAgentTelemetrySettingReactive", {
        zenGroupId: zenGroupId,
        collectAgentTelemetry: collectAgentTelemetry
    });
};

export const getGroupsGridFilterStateReactive = async () => {
    const response =  await axios.post("/getGroupsGridFilterStateReactive", {});
    return response.data;
};

export const updateGroupsGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateGroupsGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const updateGroupsGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateGroupsGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};
export const uploadSSLCertReactive = async (sslFile, zenGroupId) => {
    //have to take some extra steps in this request since we are sending a file along with zenGroupId
    const formData = new FormData()
    formData.append('file', sslFile)
    formData.append('zenGroupId', zenGroupId)
    const config  = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    return await axios.post("/uploadSSLCertReactive", formData, config);
};
export const editGroupSSLPinningModeReactive = async (zenGroupId, sslPinningModeUpdated) => {
    return await axios.post("/editGroupSSLPinningModeReactive", {
        zenGroupId: zenGroupId,
        sslPinningModeUpdated: sslPinningModeUpdated
    });
};
export const deleteSSLCertFromGroupReactive = async (zenGroupId, sha256Base64) => {
    let response =await axios.post("/deleteSSLCertFromGroupReactive", {
        zenGroupId: zenGroupId,
        sha256Base64: sha256Base64
    });
    return response.data;
};

export const getZenGroupFriendlyNamesReactive = async (zenGroupIds) => {
    const response = await axios.post("/getZenGroupFriendlyNamesReactive",{
        zenGroupIds
    })
    return response.data
}

export const getGroupsGridColumnStateReactive = async () => {
    const response =  await axios.post("/getGroupsGridColumnStateReactive", {});
    return response.data;
};
export const updateGroupsGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateGroupsGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateGroupsGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateGroupsGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};

export const editGroupAutoUpdateAgentsSettingReactive = async (zenGroupId, newAutoUpdateSetting) => {
    return await axios.post("/editGroupAutoUpdateAgentsSettingReactive", {
        zenGroupId: zenGroupId,
        newAutoUpdateSetting: newAutoUpdateSetting
    });
};
export const editGroupLatestAgentVersionApprovedSettingReactive = async (zenGroupId, newLatestAgentVersionApproved) => {
    return await axios.post("/editGroupLatestAgentVersionApprovedSettingReactive", {
        zenGroupId: zenGroupId,
        newLatestAgentVersionApproved: newLatestAgentVersionApproved
    });
};
export const editGroupPasswordExpirationPolicyReactive = async (zenGroupId, newPasswordExpirationPolicyInDays) => {
    return await axios.post("/editGroupPasswordExpirationPolicyReactive", {
        zenGroupId: zenGroupId,
        newPasswordExpirationPolicyInDays: newPasswordExpirationPolicyInDays
    });
};

export const updateGroupKernelAuthenticodeSettingsReactive = async (zenGroupId, kernelAuthenticodeSetting) => {
    return await axios.post("/updateGroupKernelAuthenticodeSettingsReactive", {
        zenGroupId: zenGroupId,
        kernelAuthenticodeSetting: kernelAuthenticodeSetting
    });
};

export const updateGroupModuleLoadSettingsReactive = async (zenGroupId, kernelAuthenticodeSetting) => {
    return await axios.post("/updateGroupModuleLoadSettingsReactive", {
        zenGroupId: zenGroupId,
        kernelAuthenticodeSetting: kernelAuthenticodeSetting
    });
};
export const updateGroupDllInsertionBehaviorSettingsReactive = async (zenGroupId, dllInsertionBehavior) => {
    return await axios.post("/updateGroupDllInsertionBehaviorSettingsReactive", {
        zenGroupId: zenGroupId,
        dllInsertionBehavior: dllInsertionBehavior
    });
};

export const updateGroupsGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateGroupsGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const getInstallScriptClientAuthReactive = async (groupId) => {
    const response =  await axios.post("/getInstallScriptClientAuthReactive", {groupId: groupId});
    return response.data;
};

export const updateShowGroupInstallerConfigIconToggledReactive = async (visible) => {
    return await axios.post("/updateShowGroupInstallerConfigIconToggledReactive", {
        visible: visible
    });
};
export const getPartnerGroupSettingsReactive = async () => {
    let response = await axios.post("/getPartnerGroupSettingsReactive", {});
    return response.data;
};
export const ccGetPartnerGroupsReactive = async () => {
    let response = await axios.post("/ccGetPartnerGroupsReactive", {});
    return response.data;
};

export const ccChangeGroupIsDistributorReactive = async (zenGroupId, newSetting, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupIsDistributorReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupIsResellerReactive = async (zenGroupId, newSetting, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupIsResellerReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupCanUseMonthlyPricingReactive = async (zenGroupId, newSetting, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupCanUseMonthlyPricingReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupIsReferralAgentReactive = async (zenGroupId, newSetting, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupIsReferralAgentReactive", {
        zenGroupId: zenGroupId,
        newSetting: newSetting,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccTurnOffChannelPartnerSettingForGroupReactive = async (zenGroupId, overrideIfDealExists) => {
    return await axios.post("/ccTurnOffChannelPartnerSettingForGroupReactive", {
        zenGroupId: zenGroupId,
        overrideIfDealExists: overrideIfDealExists
    });
};

export const ccPromoteGroupToPartnerReactive = async (zenGroupId, isDistributor, isReseller, isReferralAgent, distributorDiscount, resellerDiscount, referralDiscount,
                                                      twoYearAnnualDealDiscount, threeYearAnnualDealDiscount, twoYearPaidUpFrontDealDiscount , threeYearPaidUpFrontDealDiscount,
                                                      daysUntilInvoiceDue, canCreatePOC, partnerMaxDaysForPOCTrialLicensesToExpire, distributorContact, partnerDealDurationDays,
                                                      canUseMonthlyPricing) => {
    return await axios.post("/ccPromoteGroupToPartnerReactive", {
        zenGroupId: zenGroupId,
        isDistributor: isDistributor,
        isReseller: isReseller,
        isReferralAgent: isReferralAgent,
        distributorDiscount: distributorDiscount,
        resellerDiscount: resellerDiscount,
        referralDiscount: referralDiscount,
        twoYearAnnualDealDiscount: twoYearAnnualDealDiscount,
        threeYearAnnualDealDiscount: threeYearAnnualDealDiscount,
        twoYearPaidUpFrontDealDiscount: twoYearPaidUpFrontDealDiscount,
        threeYearPaidUpFrontDealDiscount: threeYearPaidUpFrontDealDiscount,
        daysUntilInvoiceDue: daysUntilInvoiceDue,
        canCreatePOC: canCreatePOC,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire,
        distributorContact: distributorContact,
        partnerDealDurationDays: partnerDealDurationDays,
        canUseMonthlyPricing: canUseMonthlyPricing
    });
};


export const ccChangeGroupDistributorDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupDistributorDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};


export const ccChangeGroupResellerDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupResellerDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};

export const ccChangeGroupReferralDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupReferralDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupTwoYearAnnualDealDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupTwoYearAnnualDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupThreeYearAnnualDealDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupThreeYearAnnualDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupTwoYearPaidUpFrontDealDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupTwoYearPaidUpFrontDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};
export const ccChangeGroupThreeYearPaidUpFrontDealDiscountReactive = async (zenGroupId, newDiscount, overrideIfDealExists) => {
    return await axios.post("/ccChangeGroupThreeYearPaidUpFrontDealDiscountReactive", {
        zenGroupId: zenGroupId,
        newDiscount: newDiscount,
        overrideIfDealExists: overrideIfDealExists
    });
};

export const ccChangeGroupDaysUntilInvoiceDueReactive = async (zenGroupId, newDaysUntilDue) => {
    return await axios.post("/ccChangeGroupDaysUntilInvoiceDueReactive", {
        zenGroupId: zenGroupId,
        newDaysUntilDue: newDaysUntilDue
    });
};

export const ccChangeGroupDaysUntilDealExpiresReactive = async (zenGroupId, newPartnerDealDurationDays) => {
    return await axios.post("/ccChangeGroupDaysUntilDealExpiresReactive", {
        zenGroupId: zenGroupId,
        newPartnerDealDurationDays: newPartnerDealDurationDays
    });
};

export const ccChangeGroupMaxDaysUntilTrialLicensesExpireReactive = async (zenGroupId, partnerMaxDaysForPOCTrialLicensesToExpire) => {
    return await axios.post("/ccChangeGroupMaxDaysUntilTrialLicensesExpireReactive", {
        zenGroupId: zenGroupId,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire
    });
};
export const ccChangeDistributorContactReactive = async (zenGroupId, distributorContact) => {
    return await axios.post("/ccChangeDistributorContactReactive", {
        zenGroupId: zenGroupId,
        distributorContact: distributorContact
    });
};


export const editGroupCanaryExtensionModeReactive = async (zenGroupId, canaryExtensionMode) => {
    return await axios.post("/editGroupCanaryExtensionModeReactive", {
        zenGroupId: zenGroupId,
        canaryExtensionMode: canaryExtensionMode
    });
};

export const ccGetPartnerGroupDaysUntilInvoiceDueSettingsReactive = async (zenGroupId) => {
    let response = await axios.post("/ccGetPartnerGroupDaysUntilInvoiceDueSettingsReactive", {
        zenGroupId: zenGroupId
    })
    return response.data;
};

export const resendUserInvitationReactive = async (username, zenGroupId) => {
    return await axios.post("/resendUserInvitationReactive", {
        username: username,
        zenGroupId: zenGroupId
    });
};

export const ccCreateNewPartnerGroupReactive = async (newPartnerGroupName, groupOwnerUsername, isDistributor, isReseller, isReferralAgent, distributorDiscount, resellerDiscount, referralDiscount,
                                                      twoYearAnnualDealDiscount, threeYearAnnualDealDiscount,twoYearPaidUpFrontDealDiscount, threeYearPaidUpFrontDealDiscount,
                                                      daysUntilInvoiceDue, canCreatePOC, partnerMaxDaysForPOCTrialLicensesToExpire, distributorContact, partnerDealDurationDays,
                                                      canUseMonthlyPricing) => {
    return await axios.post("/ccCreateNewPartnerGroupReactive", {
        newPartnerGroupName: newPartnerGroupName,
        groupOwnerUsername: groupOwnerUsername,
        isDistributor: isDistributor,
        isReseller: isReseller,
        isReferralAgent: isReferralAgent,
        distributorDiscount: distributorDiscount,
        resellerDiscount: resellerDiscount,
        referralDiscount: referralDiscount,
        twoYearAnnualDealDiscount: twoYearAnnualDealDiscount,
        threeYearAnnualDealDiscount: threeYearAnnualDealDiscount,
        twoYearPaidUpFrontDealDiscount: twoYearPaidUpFrontDealDiscount,
        threeYearPaidUpFrontDealDiscount: threeYearPaidUpFrontDealDiscount,
        daysUntilInvoiceDue: daysUntilInvoiceDue,
        canCreatePOC: canCreatePOC,
        partnerMaxDaysForPOCTrialLicensesToExpire: partnerMaxDaysForPOCTrialLicensesToExpire,
        distributorContact: distributorContact,
        partnerDealDurationDays: partnerDealDurationDays,
        canUseMonthlyPricing: canUseMonthlyPricing
    });
};

export const ccChangeGroupCanCreatePOCReactive = async (zenGroupId, canCreatePOC) => {
    return await axios.post("/ccChangeGroupCanCreatePOCReactive", {
        zenGroupId: zenGroupId,
        canCreatePOC: canCreatePOC
    });
};

export const updateGroupAgentInactiveDaysReactive = async (zenGroupId, newAgentInactiveDaysSetting) => {
    return await axios.post("/updateGroupAgentInactiveDaysReactive", {
        zenGroupId: zenGroupId,
        newAgentInactiveDaysSetting: newAgentInactiveDaysSetting
    });
};
export const updateGroupRollingUpdatePercentageReactive = async (zenGroupId, rollingUpdatePercentage) => {
    return await axios.post("/updateGroupRollingUpdatePercentageReactive", {
        zenGroupId: zenGroupId,
        rollingUpdatePercentage: rollingUpdatePercentage
    });
};

export const updateGroupRunAgentsInSafeModeReactive = async (zenGroupId, runAgentsInSafeMode) => {
    return await axios.post("/updateGroupRunAgentsInSafeModeReactive", {
        zenGroupId: zenGroupId,
        runAgentsInSafeMode: runAgentsInSafeMode
    });
};

export const addGroupProxyConfigReactive = async (zenGroupId, url, username, password) => {
    return await axios.post("/addGroupProxyConfigReactive", {
        zenGroupId: zenGroupId,
        url: url,
        username: username,
        password: password
    });
};
export const removeGroupProxyConfigReactive = async (zenGroupId, url, username) => {
    return await axios.post("/removeGroupProxyConfigReactive", {
        zenGroupId: zenGroupId,
        url: url,
        username: username
    });
};
export const editGroupProxyConfigReactive = async (zenGroupId, url, username) => {
    return await axios.post("/editGroupProxyConfigReactive", {
        zenGroupId: zenGroupId,
        url: url,
        username: username
    });
};
export const updateGroupToNotUseProxyServerReactive = async (zenGroupId) => {
    return await axios.post("/updateGroupToNotUseProxyServerReactive", {
        zenGroupId: zenGroupId,
    });
};

export const updateGroupAutomaticallyHideAgentsReactive = async (zenGroupId, hideAgentsAutomatically) => {
    return await axios.post("/updateGroupAutomaticallyHideAgentsReactive", {
        zenGroupId: zenGroupId,
        hideAgentsAutomatically: hideAgentsAutomatically
    });
};
export const editGroupEarlyAdopterReactive = async (zenGroupId, earlyAdopter) => {
    return await axios.post("/editGroupEarlyAdopterReactive", {
        zenGroupId: zenGroupId,
        earlyAdopter: earlyAdopter
    });
};
export const updateGroupModuleMemoryTelemetryReactive = async (zenGroupId, enabled) => {
    return await axios.post("/updateGroupModuleMemoryTelemetryReactive", {
        zenGroupId: zenGroupId,
        enabled: enabled
    });
};
export const updateGroupDmzModeReactive = async (zenGroupId, dmzMode) => {
    return await axios.post("/updateGroupDmzModeReactive", {
        zenGroupId: zenGroupId,
        dmzMode: dmzMode
    });
};
export const updateGroupEnforceSSOLoginReactive = async (zenGroupId, enforceSSOLogin) => {
    return await axios.post("/updateGroupEnforceSSOLoginReactive", {
        zenGroupId: zenGroupId,
        enforceSSOLogin: enforceSSOLogin
    });
};
export const updateGroupEnableIncidentAutoDeleteReactive = async (zenGroupId, enableIncidentAutoDelete) => {
    return await axios.post("/updateGroupEnableIncidentAutoDeleteReactive", {
        zenGroupId: zenGroupId,
        enableIncidentAutoDelete: enableIncidentAutoDelete
    });
};
export const updateGroupEnableSystemTrayReactive = async (zenGroupId, enableSystemTray) => {
    return await axios.post("/updateGroupEnableSystemTrayReactive", {
        zenGroupId: zenGroupId,
        enableSystemTray: enableSystemTray
    });
};
export const editGroupIdentityBlocksAndHidesVisibleCCOnly = async (zenGroupId, newSetting) => {
    return await axios.post("/editGroupIdentityBlocksAndHidesVisibleCCOnly", {
        zenGroupId: zenGroupId,
        newSetting: newSetting
    });
};
export const bulkEditGroupsIdentityVisibilityCCOnly = async (zenGroupIds, identityBlocksAndHidesVisible) => {
    return await axios.post("/bulkEditGroupsIdentityVisibilityCCOnly", {
        zenGroupIds: zenGroupIds,
        identityBlocksAndHidesVisible: identityBlocksAndHidesVisible,
    })
};
export const cloneExistingGroup = async (zenGroupId) => {
    return await axios.post("/cloneExistingGroup", {
        zenGroupId: zenGroupId
    })
}
export const updateGroupFortressAIReportModeReactive = async (zenGroupId, fortressAIReportMode) => {
    return await axios.post("/updateGroupFortressAIReportModeReactive", {
        zenGroupId: zenGroupId,
        fortressAIReportMode: fortressAIReportMode
    })
}
export const updateGroupModuleTelemetryModeReactive = async (zenGroupId, moduleTelemetryMode) => {
    return await axios.post("/updateGroupModuleTelemetryModeReactive", {
        zenGroupId: zenGroupId,
        moduleTelemetryMode: moduleTelemetryMode
    }).then(response => response.data)
}
export const editGroupAgentKernelNetworkingReactive = async (zenGroupId, agentKernelNetworking) => {
    return await axios.post("/editGroupAgentKernelNetworkingReactive", {
        zenGroupId: zenGroupId,
        agentKernelNetworking: agentKernelNetworking
    }).then(response => response.data)
}
export const editGroupCreationsBufferCapacityCCOnly = async (zenGroupId, newCapacity) => {
    return await axios.post("/editGroupCreationsBufferCapacityCCOnly", {
        zenGroupId: zenGroupId,
        newCapacity: newCapacity
    })
}
export const editGroupInjectionsBufferCapacityCCOnly = async (zenGroupId, newCapacity) => {
    return await axios.post("/editGroupInjectionsBufferCapacityCCOnly", {
        zenGroupId: zenGroupId,
        newCapacity: newCapacity
    })
}
export const editGroupModuleLoadsBufferCapacityCCOnly = async (zenGroupId, newCapacity) => {
    return await axios.post("/editGroupModuleLoadsBufferCapacityCCOnly", {
        zenGroupId: zenGroupId,
        newCapacity: newCapacity
    })
}